<template>
  <layout :title="$route.name" :options="[]">
    <v-container>
      <v-alert v-if="walletError" type="warning" outlined>{{ walletError }}</v-alert>
      <v-card class="pa-5 mb-4" :loading="walletLoading">
        <div class="text-overline">Saldo disponível</div>
        <div class="text-h4 font-weight-bold">{{ money(account.availableBalance) }}</div>
        <div class="grey--text mt-1">Bloqueado/em processamento: {{ money(account.blockedBalance) }}</div>
        <v-row class="mt-4">
          <v-col cols="12" sm="4"><v-btn block color="primary" to="/conta-scn/adicionar"><v-icon left>mdi-qrcode</v-icon>Adicionar</v-btn></v-col>
          <v-col cols="12" sm="4"><v-btn block outlined color="primary" to="/conta-scn/transferir"><v-icon left>mdi-swap-horizontal</v-icon>Transferir</v-btn></v-col>
          <v-col cols="12" sm="4"><v-btn block outlined color="primary" to="/conta-scn/sacar"><v-icon left>mdi-bank-transfer-out</v-icon>Sacar</v-btn></v-col>
        </v-row>
      </v-card>
      <v-card>
        <v-card-title>Extrato</v-card-title>
        <v-list v-if="walletTransactions.length">
          <template v-for="item in walletTransactions">
            <v-list-item :key="item.id + item.direction">
              <v-list-item-content><v-list-item-title>{{ item.description }}</v-list-item-title><v-list-item-subtitle>{{ item.type }} · {{ item.status }} · {{ date(item.createdAt) }}</v-list-item-subtitle></v-list-item-content>
              <v-list-item-action :class="item.direction === 'CREDIT' ? 'green--text' : 'red--text'">{{ item.direction === "CREDIT" ? "+" : "-" }} {{ money(item.amount) }}</v-list-item-action>
            </v-list-item><v-divider :key="item.id + '-divider'" />
          </template>
        </v-list>
        <v-card-text v-else>Nenhuma movimentação na Conta SCN.</v-card-text>
      </v-card>
    </v-container>
  </layout>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters(["walletAccount", "walletTransactions", "walletLoading", "walletError"]),
    account() { return this.walletAccount || { availableBalance: 0, blockedBalance: 0 }; }
  },
  created() { this.$store.dispatch("loadWallet").catch(() => {}); },
  methods: {
    money(value) { return new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" }).format((value || 0) / 100); },
    date(value) { return value ? new Date(value).toLocaleString("pt-BR") : ""; }
  }
};
</script>
